import { CookieModule, LoggerModule,  } from "@packages/common";
import type { Module } from "@webmotors/ioc";
import { LastSearchesService } from "./last-searches.service";

export const LastSearchesModule: Module = {
    name: "LastSearchesModule",
    modules: [LoggerModule, CookieModule],
    providers: [LastSearchesService],
  };
  